import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // customize your primary color
    },
    secondary: {
      main: '#dc004e', // customize your secondary color
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // prevents all-caps button text
        },
      },
    },
  },
});

export default theme; 